import { gql } from '@grandvisionhq/graphql';

const CANCEL_ANONYMOUS_SUBSCRIPTION = gql`
  mutation CancelAnonymousSubscription($subscriptionId: String!, $details: CancelDetailsInput!) {
    cancelAnonymousSubscription(subscriptionId: $subscriptionId, details: $details) {
      ... on CancelAnonymousSubscriptionSuccessResponse {
        result {
          cancelDate
          subscriptionId
        }
      }
      ... on CancelAnonymousSubscriptionFailureResponse {
        failures {
          ... on SubscriptionNotFoundFailure {
            message
          }
          ... on UnauthorizedFailure {
            message
          }
          ... on InvalidInputFailure {
            message
          }
          ... on InvalidTerminationDateFailure {
            message
          }
        }
      }
    }
  }
`;

export { CANCEL_ANONYMOUS_SUBSCRIPTION };
//# sourceMappingURL=cancel-anonymous-subscription.js.map
